<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

interface StepCard {
  id: string
  number: number
  title: string
  description: string
}

const steps = computed<StepCard[]>(() => [
  {
    id: 'register',
    number: 1,
    title: t('registration'),
    description: t('join_easily'),
  },
  {
    id: 'setup-tools',
    number: 2,
    title: t('setup_tools'),
    description: t('setup_tools_description'),
  },
  {
    id: 'grow-sales',
    number: 3,
    title: t('increase_sales'),
    description: t('increase_sales_description'),
  },
])
</script>

<template>
  <section class="py-8 md:py-20">
    <div class="container mx-auto flex flex-col gap-4 md:gap-10">
      <h2
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="300"
        class="font-semibold text-[32px] sm:text-4xl md:text-5xl text-[#172026] text-center leading-10 md:leading-[72px]"
      >
        {{ $t("how_to_start") }}
      </h2>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 lg:gap-7">
        <div
          v-for="(step, index) in steps"
          :key="step.id"
          :data-aos="
            index === 0 ? 'fade-right' : index === 1 ? 'fade-up' : 'fade-left'
          "
          :data-aos-duration="1000"
          :data-aos-delay="500 + index * 200"
          class="bg-[#F4F8FA] rounded-2xl py-8 px-6 flex flex-col gap-4"
        >
          <div
            class="w-8 h-8 rounded-lg bg-[#A83AFD1A] flex items-center justify-center font-semibold"
          >
            <span class="text-[#A83AFD] text-lg leading-6">
              {{ step.number }}
            </span>
          </div>
          <h3 class="font-semibold text-xl leading-[130%] text-[#172026]">
            {{ step.title }}
          </h3>
          <p
            class="font-normal text-sm leading-[150%] sm:text-base text-[#36485C]"
          >
            {{ step.description }}
          </p>
        </div>
      </div>

      <div
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-delay="1200"
        class="justify-end competitors bg-[#F4F8FA] rounded-2xl py-6 md:py-[53px] px-4 md:px-20 flex flex-col lg:flex-row items-center gap-6 md:gap-10 lg:bg-[url('@/shared/assets/png/competitors.png')] bg-no-repeat bg-bottom-left"
      >
        <div class="max-w-[764px] w-full h-auto">
          <h3
            class="font-semibold text-2xl sm:text-3xl md:text-[42px] leading-9 md:leading-[58px] text-[#172026] mb-3 md:mb-5 text-center sm:text-left"
          >
            {{ $t("dont_stay_behind") }}
          </h3>
          <p
            class="font-normal text-sm sm:text-xl text-[#36485C] leading-6 sm:leading-7 text-center sm:text-left mb-4"
          >
            {{ $t("start_using_marketassist") }}
          </p>
          <img
            src="@/shared/assets/png/competitors.png"
            alt="competitors"
            class="h-[253px] mx-auto lg:hidden"
          >
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.competitors {
  background-size: 282px;
}
</style>
